<div class="boneMap_container" data-testid="SUBSYS2_PLANFORM_BONEMAP_BOX">
	<maphilight id="statesMap" [config]="config">

		<img src="images/bilateralPlan.png" alt="skeleton" style="width: 100%;">

		<map name="image-map">
			@for (item of boneMap | keyvalue; track $index) {
			<area shape="poly" alt="bone area" [id]="item.key" [coords]="item.value.coords">
			}
		</map>
	</maphilight>

	@if (!disabled) {
	<div class="imageMap_container" data-testid="SUBSYS2_PLANFORM_BONEMAP_POINTS_BOX">

		@for (item of markerMap | keyvalue; track item.key) {
		<div class="markers" [attr.data-testid]="item.value.testId"
			[style]="{'grid-column': item.value.gridColumn, 'grid-row': item.value.gridRow}"
			(click)="highlightArea($event, item.value.site)" (keypress)="highlightArea($event, item.value.site)"
			[ngbTooltip]="tooltipTemplate" tooltipClass="markers-tooltip"
			[placement]="item.value.site.includes('Right')?'left-bottom':'right-bottom'">


			<ng-template #tooltipTemplate>
				<span>{{ item.value.site | anatomicalSiteLabel }}</span>
			</ng-template>
		</div>
		}

	</div>
	}
</div>